export default "__VITE_ASSET__b126adf2__"